import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

const BudgetDashboard = () => {
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontFamily: "'Arial', sans-serif",
    backgroundColor: "#f8f9fb",
    padding: "20px",
    minHeight: "100vh",
  };

  const headerStyle = {
    textAlign: "left",
    width: "100%",
    maxWidth: "1200px",
    marginBottom: "20px",
  };

  const greetingStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
  };

  const subGreetingStyle = {
    fontSize: "14px",
    color: "#777",
  };

  const cardContainerStyle = {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "1200px",
    marginBottom: "20px",
  };

  const cardStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    width: "48%",
  };

  const chartSectionStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "20px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "1200px",
    marginTop: "20px",
    overflowX: "auto", // Enable horizontal scrolling for large charts
  };

  const chartTitleStyle = {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "20px",
  };

  const districtsData = [
    { district: "District 1", allotment: 50000, expense: 45000 },
    { district: "District 2", allotment: 60000, expense: 58000 },
    { district: "District 3", allotment: 70000, expense: 69000 },
    { district: "District 4", allotment: 80000, expense: 75000 },
    { district: "District 5", allotment: 90000, expense: 85000 },
    { district: "District 6", allotment: 45000, expense: 40000 },
    { district: "District 7", allotment: 72000, expense: 70000 },
    { district: "District 8", allotment: 81000, expense: 79000 },
    { district: "District 9", allotment: 62000, expense: 59000 },
    { district: "District 10", allotment: 55000, expense: 50000 },
    { district: "District 11", allotment: 73000, expense: 70000 },
    { district: "District 12", allotment: 61000, expense: 58000 },
    { district: "District 13", allotment: 78000, expense: 74000 },
    { district: "District 14", allotment: 67000, expense: 62000 },
    { district: "District 15", allotment: 56000, expense: 53000 },
    { district: "District 16", allotment: 89000, expense: 86000 },
    { district: "District 17", allotment: 49000, expense: 47000 },
    { district: "District 18", allotment: 85000, expense: 81000 },
    { district: "District 19", allotment: 63000, expense: 61000 },
    { district: "District 20", allotment: 92000, expense: 88000 },
    { district: "District 21", allotment: 47000, expense: 43000 },
    { district: "District 22", allotment: 76000, expense: 72000 },
    { district: "District 23", allotment: 68000, expense: 64000 },
    { district: "District 24", allotment: 59000, expense: 54000 },
    { district: "District 25", allotment: 88000, expense: 85000 },
    { district: "District 26", allotment: 67000, expense: 62000 },
    { district: "District 27", allotment: 56000, expense: 51000 },
  ];

  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <p style={greetingStyle}>Good Morning, Ilham</p>
        <p style={subGreetingStyle}>Welcome to your financial insights.</p>
      </div>

      <div style={cardContainerStyle}>
        <div style={cardStyle}>
          <p>Total Balance</p>
          <h2>30,192.98</h2>
        </div>
        <div style={cardStyle}>
          <p>Income</p>
          <h2>40,000.00</h2>
        </div>
      </div>

      <div style={chartSectionStyle}>
        <h2 style={chartTitleStyle}>Allotment vs Expense for Districts</h2>
        <div style={{ overflowX: "scroll" }}>
          <BarChart
            width={1600} // Increased width to fit all bars
            height={500}
            data={districtsData}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="district" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="allotment" fill="#82ca9d" />
            <Bar dataKey="expense" fill="#8884d8" />
          </BarChart>
        </div>
      </div>
    </div>
  );
};

export default BudgetDashboard;
